
import SlideShow from 'slide-show/module.js';
import events from 'dom/events.js';

// Restart video from 0 when slide is activated
events('slide-active', document.body)
.each((e) => {
    const video = e.target.querySelector('video');
    if (video) video.currentTime = 0;
});
